import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=7dfc0956&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"
import style0 from "./footers.vue?vue&type=style&index=0&id=7dfc0956&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc0956",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutFooterNav: require('D:/Project/kpwebsite/PC/components/layout/footerNav.vue').default})
